/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import { useState, useContext, useEffect } from "react";
import { PatientsContext } from ".";
import Pagination from "../../components/Pagination";
import fetchHelper from "../../services/fetchHelper";
import TasksForm from "./TasksForm";
import TasksRow from "./TasksRow";

const TasksTable = ({ shouldRefresh, setShouldRefresh }) => {
  const { patientTasks, addPatientTask, setPatientTasksOffset, patientTasksOffset, patient } =
    useContext(PatientsContext);
  const [initialLoad, setInitialLoad] = useState(false);
  const [initialOffset, setInitialOffset] = useState(false);
  const [offset, setOffset] = useState(0);
  const [to, setTo] = useState(null);
  const PageLimitSize = 10;

  useEffect(() => {
    if (!initialOffset) {
      fetchTasks();
      setPatientTasksOffset(offset);
    }
  }, [offset]);

  useEffect(() => {
    if (initialOffset) fetchTasks();
  }, [initialOffset]);

  useEffect(() => {
    if (shouldRefresh) fetchTasks();
  }, [shouldRefresh]);

  const fetchTasks = async () => {
    try {
      setInitialLoad(true);
      if (initialOffset) setOffset(patientTasksOffset);
      const response = await fetchHelper.get({
        url: `/patientmanagement/rest/engagement/tasks?patientId=${patient.id}`,
        headers: {
          "X-Range": `items=${offset}-${offset + PageLimitSize - 1}`,
          Range: `items=${offset}-${offset + PageLimitSize - 1}`,
        },
      });
      addPatientTask(response);
      setTo(offset + response.length - 1);
    } catch ({ errors }) {
      console.log(errors);
    } finally {
      setInitialLoad(false);
      setInitialOffset(false);
      setShouldRefresh(false);
    }
  };

  return (
    <>
      <div className="content task-table">
        <div className="grpHdr">
          <h3>Patient Tasks</h3>
        </div>
        {patientTasks.openFormTask && <TasksForm shouldRefresh={setShouldRefresh} />}
        <table className="overview" id="pe-patient-data-table">
          <thead>
            <tr style={{ textAlign: "left", background: "#f7f7f7" }}>
              <th>Date &amp; Time Submitted</th>
              <th>Submitted by</th>
              <th>Reason for Request</th>
              <th>Device</th>
              <th>Note</th>
              <th>Date &amp; Time Closed</th>
              <th>Reserved by</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {patientTasks.list &&
              patientTasks.list.map((item, key) => (
                <TasksRow data={item} key={key} setInitialOffset={setInitialOffset} />
              ))}
          </tbody>
        </table>
      </div>
      <Pagination
        offset={offset}
        to={to}
        limit={PageLimitSize}
        onSetOffset={setOffset}
        loading={initialLoad}
      />
    </>
  );
};
export default TasksTable;
